import {
  PlanFreeIcon,
  PlanPremiumIcon,
  PlanPremiumFridayIcon,
} from 'src/assets'

const PLANS = (
  timeInterval,
  basicPackage,
  proPackage,
  groupId,
  getAction,
  getDisabledStatus,
) => [
  {
    subscription: 'Basic',
    icon: <PlanFreeIcon />,
    price: 0,
    groupId,
    caption: 'Free Forever',
    lists: [
      { text: 'Unlimited user engagement', isAvailable: true },
      { text: '3 mini-courses', isAvailable: true },
      { text: 'Analytics for limited users', isAvailable: true },
      { text: 'Customization of layout & theme', isAvailable: true },
      { text: 'Issue digital badges', isAvailable: true },
      { text: 'Delivering by link & embedding', isAvailable: true },
    ],
    action: getAction(groupId, 'Basic'),
  },
  {
    subscription: 'Pro',
    icon: <PlanPremiumIcon />,
    price: timeInterval ? 25 : 49,
    priceId: timeInterval
      ? 'price_1QjbbbI6xu65zAZTGEbeMgqu'
      : 'price_1QjbYvI6xu65zAZTbiSnyj1I',
    priceTrialDays: null,
    groupId,
    basicPackage,
    proPackage,
    successReturnUrl: timeInterval
      ? 'annual-pro-subscription-successful'
      : 'pro-subscription-successful',
    caption: timeInterval ? 'Save 50% when billed annually' : '',
    lists: [
      { text: 'Unlimited mini-courses & landing pages', isAvailable: true },
      { text: '1.000 AI Credits for AI course creation', isAvailable: true },
      { text: 'Analytics for all users', isAvailable: true },
      { text: 'Up to 5 custom domains', isAvailable: true },
      {
        text:
          'Adding gateways (email verification, paywall, or invitation-only access)',
        isAvailable: true,
      },
      { text: 'Removal of MCG Badge', isAvailable: true },
    ],
    action: getAction(groupId, 'Pro'),
  },
  {
    subscription: 'Elite',
    icon: <PlanPremiumFridayIcon />,
    price: timeInterval ? 50 : 99,
    priceId: timeInterval
      ? 'price_1QjbtkI6xu65zAZTiViVxA8N'
      : 'price_1Q14e5I6xu65zAZTYQGCN6XF',
    priceTrialDays: null,
    basicPackage,
    groupId,
    proPackage,
    successReturnUrl: timeInterval
      ? 'annual-elite-subscription-successful'
      : 'elite-subscription-successful',
    caption: timeInterval ? 'Save 50% when billed annually' : '',
    lists: [
      { text: '3.000 AI credits for AI Course Creation', isAvailable: true },
      { text: 'Export to SCORM packages', isAvailable: true },
      { text: 'Unlimited custom domains', isAvailable: true },
      { text: 'In-app authentication (250 users/month)', isAvailable: true },
      { text: 'In-Intercom academy (1.000 users/month)', isAvailable: true },
      { text: 'Dedicated account manager', isAvailable: true },
    ],
    action: getAction(groupId, 'Elite'),
  },
]

export default PLANS
